export const api = (process.env.NODE_ENV === "production") ? "https://api-start.checkstore.app" : "http://127.0.0.1:8080"